import styled from "styled-components";

import { FlexDiv } from "../../Atoms";

export const StyledAvatar = styled(FlexDiv)`
  margin: 0 8px 8px;
  width: 100%;
  text-align: center;
  align-items: center;
  padding: 8px 0;
  .image-box {
    margin: 0 16px 0 0;
  }
  &.column {
    flex-direction: column;
    .image-box {
      margin: 0 0 16px 0;
    }
  }
`;

export const ImageBox = styled(FlexDiv)`
  border-radius: 50%;
  overflow: hidden;
  ${({ hasBoxShadow, theme }) =>
    hasBoxShadow && `box-shadow: 0 0 0 4px ${theme.colorsV2.shyft.cream};`}
  img {
    height: 100%;
    max-height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;
